import { initWidget, isWidgetContext } from "./widget-api";
import { authenticateWithMatrix, buildGameUrl } from "./auth";

const loadingEl = document.getElementById("loading")!;
const errorEl = document.getElementById("error")!;
const errorText = errorEl.querySelector(".error-text")!;
const retryBtn = document.getElementById("retry-btn")!;
const gameFrame = document.getElementById("game-frame") as HTMLIFrameElement;

// Debug: log all incoming postMessages so we can see what Element is sending
window.addEventListener("message", (ev) => {
  console.log("[CoHo Widget] postMessage received:", {
    origin: ev.origin,
    data: ev.data,
    source: ev.source === window.parent ? "parent" : "other",
  });
});

// Debug: log location info
console.log("[CoHo Widget] Location:", {
  href: window.location.href,
  search: window.location.search,
  hash: window.location.hash,
  origin: window.location.origin,
  inIframe: window.self !== window.top,
});

function showError(msg: string) {
  loadingEl.style.display = "none";
  errorEl.style.display = "flex";
  errorText.textContent = msg;
}

function showGame(url: string) {
  loadingEl.style.display = "none";
  errorEl.style.display = "none";
  gameFrame.style.display = "block";
  gameFrame.src = url;
}

async function boot() {
  loadingEl.style.display = "flex";
  errorEl.style.display = "none";
  gameFrame.style.display = "none";

  // If not running inside a Matrix client, show a helpful message
  if (!isWidgetContext()) {
    showError(
      "This page is a Matrix widget for Cosmic Horizon. " +
        "Add it to a Matrix room in Element to play. " +
        "Widget URL: " +
        window.location.origin,
    );
    return;
  }

  try {
    // 1. Initialize the Matrix Widget API and get OpenID token
    const ctx = await initWidget();
    console.log("[CoHo Widget] Connected as", ctx.userId);

    // 2. Authenticate with the Cosmic Horizon server
    const auth = await authenticateWithMatrix(ctx.openIdToken, ctx.userId);
    console.log(
      "[CoHo Widget] Authenticated:",
      auth.player.username,
      auth.isNewPlayer ? "(new)" : "(existing)",
    );

    // 3. Load the game client in the iframe
    const gameUrl = buildGameUrl(auth.token);
    showGame(gameUrl);

    // Keep the widget visible
    ctx.api.setAlwaysOnScreen(true);
  } catch (err) {
    console.error("[CoHo Widget] Boot failed:", err);
    showError(err instanceof Error ? err.message : String(err));
  }
}

retryBtn.addEventListener("click", boot);
boot();
